import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import styled, { keyframes } from 'styled-components'
import Text from '../../components/Text'
import ui from '../../stores/ui'

const Button = styled.button`
  background: ${props => `var(--${props.color})`};
  color: #fff;
  font-size: ${props => props.small ? '1.25rem' : '1.5rem'};
  width: ${props => props.small ? '2.5rem' : '3rem'};
  height: ${props => props.small ? '2.5rem' : '3rem'};
  margin: 0 1.25rem 1.25rem 0;
  font-weight: 300;
  border-radius: 10px;
  cursor: pointer;
  display: block;
  border: 2px solid ${props => `var(--${props.color})`};
  &:first-child {
    margin-left: 0;
  }
`

const ButtonContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`

// Don't get rid of this; this fixes a bug in safari with prompt cards displaying incorrectly for
// some reason. No idea why, but animations fixes the problem.
const animation = keyframes`
  from {
    opacity: 0;
    top: -1rem;
  }
  to {
    opacity: 1;
    top: 0;
  }
`

const Card = styled.button`
  background: #fff;
  color: #000;
  width: 100%;
  padding: ${props => props.small ? '1rem' : '1.25rem'};
  margin: 0 0 1.25rem 0;
  border: 2px solid ${props => `var(--${props.color})`};
  text-align: left;
  cursor: pointer;
  border-radius: 10px;
  position: relative;
  animation: ${animation} linear 0.2s;
  display: block;
  ${'' /* Makes sure that all prompts, even those with children defined, have the correct font. */}
  &>* {
    font-size: ${props => props.small ? '0.9rem' : '1rem'} !important;
    line-height: 150% !important;
  }
`

@observer
export default class Prompt extends Component {
  @observable opened = false

  @action
  toggle = () => {
    this.opened = !this.opened
  }

  render() {
    const { str, letter, color, inserts, children, small } = this.props

    if (ui.promptsHidden) {
      return <Fragment></Fragment>
    }

    return (
      <Fragment>
        {!ui.allPromptsOpen && !this.opened &&
          <Button color={color} onClick={this.toggle} small={small}>
            <ButtonContent>
              {letter}
            </ButtonContent>
          </Button>
        }
        {(ui.allPromptsOpen || this.opened) &&
          <Card color={color} onClick={this.toggle} small={small}>
            {str &&
              <Text str={str} inserts={inserts} />
            }
            {!str && children}
          </Card>
        }
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Prompts/Prompt.js